import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';
import _isArray from 'lodash/isArray';
import _isObject from 'lodash/isObject';
import _isNil from 'lodash/isNil';
import { useIntl } from 'react-intl';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';
import { Text } from '@lifeomic/chroma-react/components/Text';
import ReactJson from 'react-json-view';
import { MessageDescriptor } from '../../../util/types';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    overflowY: 'auto',
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.graphite[200]}`,
    backgroundColor: theme.palette.common.white,
  },
}));

export type JSONDisplayClasses = GetClasses<typeof useStyles>;

export interface JSONDisplayOwnProps {
  displayInput: any;
  invalidIntlMessage: MessageDescriptor;
}

export type JSONDisplayProps = JSONDisplayOwnProps;

const JSONDisplay = (props: JSONDisplayProps) => {
  const formatMessage = useIntl().formatMessage;
  const classes = useStyles(props);
  const { displayInput, invalidIntlMessage } = props;

  const isNil = _isNil(displayInput);
  const isEmptyString = _isString(displayInput) && _isEmpty(displayInput);
  const isEmptyArray = _isArray(displayInput) && _isEmpty(displayInput);
  const isEmptyObject = _isObject(displayInput) && _isEmpty(displayInput);

  const hasNoResults = isNil || isEmptyString || isEmptyArray || isEmptyObject;
  const isJSONInput =
    (_isObject(displayInput) || _isArray(displayInput)) && !hasNoResults;

  if (isJSONInput) {
    return (
      <div className={classes.root}>
        <ReactJson
          enableClipboard={false}
          src={displayInput}
          name={null}
          displayDataTypes={false}
        />
      </div>
    );
  } else if (!hasNoResults) {
    return <Text>{`"${displayInput}"`}</Text>;
  } else {
    return <Text> {formatMessage(invalidIntlMessage)}</Text>;
  }
};

export default React.memo(JSONDisplay);
